import React, { Dispatch, SetStateAction } from 'react';
import { AddressVerificationResponse } from '../addressVerificationTypes';
import { NO_SUGGESTION } from '../constants';
import NoSuggestionAddress from '../NoSuggestionAddress';
import SuggestionAddress from '../SuggestionAddress';

export default function buildAddresses(
  modalType: string | undefined,
  setAddressSelected: Dispatch<SetStateAction<string>>,
  addressSelected: string,
  addressVerificationResponse: AddressVerificationResponse,
  setShowAddressVerification: Dispatch<SetStateAction<boolean>>,
) {
  function handleKeyPress(
    event: React.KeyboardEvent<HTMLDivElement>,
    clickedAddress: string,
  ) {
    setAddressSelected(clickedAddress);
  }

  function handleClick(clickedAddress: string) {
    setAddressSelected(clickedAddress);
  }

  const { submitted, verified } = addressVerificationResponse;
  if (modalType === NO_SUGGESTION) {
    return <NoSuggestionAddress address={submitted} />;
  }
  return (
    <SuggestionAddress
      submittedAddress={submitted}
      verifiedAddress={verified}
      handleKeyPress={handleKeyPress}
      handleClick={handleClick}
      addressSelected={addressSelected}
      setShowAddressVerification={setShowAddressVerification}
    />
  );
}
